export const CHECKOUT_URL =
  'https://motorcycle-diagnostic-pro.impultienda.ar/checkout'

/** Anchor id of the $26.90 purchase section */
export const OFFER_ANCHOR = '#offer'

export const MOCKUP_IMAGE =
  'https://cdn.magicpatterns.com/uploads/6orPFZGKr9iVh5sfDNZjqb/Diseno-sin-titulo-4-2.webp'

export const PRODUCT = 'MOTORCYCLE DIAGNOSTIC PRO™'
